import { useEffect } from "react"
import { applyAppBadge } from "@/lib/appBadge"

/**
 * Keeps the app icon badge equal to `count`. Applied only when the value
 * changes; see `lib/appBadge.ts` for why it is not repainted more often.
 */
export const useAppBadge = (count: number): void => {
  useEffect(() => {
    void applyAppBadge(count, "change")
  }, [count])
}

export default useAppBadge
